import { render, staticRenderFns } from "./SummaryBox.vue?vue&type=template&id=e8305464&"
import script from "./SummaryBox.vue?vue&type=script&lang=js&"
export * from "./SummaryBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports